class UserSource {
    constructor(API) {
        this.API = API;
    }

    async get(id) {
        return await this.API.get('/index.php?route=api/users/' + id, {
            headers: {
                'Content-type':'application/json'
            }
        })
    }
    async logout() {
        return await this.API.post('/index.php?route=api/customer/logout')
    }
    async uploadImage(data) {
        return await this.API.post('/index.php?route=api/upload', data)
    }


    async saveProfile(data) {
        return await this.API.post('/index.php?route=api/customer/update', data)
    }

    async setImageProfile(data) {
        return await this.API.post('/index.php?route=api/customer/setImageProfile', data)
    }

}

export default UserSource
